// extracted by mini-css-extract-plugin
module.exports = {"fileBlock":"fileBlock_fileBlock__Q6vay"};